import { Alert, Badge, fmt } from "@nabble/ui";
import type { AdminDataRequest } from "../../../api/adminDataRequests";
import { isAnswered, STATUS_LABEL, STATUS_TONE } from "../../../model/dataRequests";

/** A titled block of free text written by the person or by an administrator. */
function TextSection({ title, text }: { title: string; text: string }): React.JSX.Element {
  return (
    <section>
      <div className="nb-setting-title">{title}</div>
      <p className="nb-help" style={{ whiteSpace: "pre-wrap", margin: "4px 0 0" }}>
        {text}
      </p>
    </section>
  );
}

/** Everything known about a data request: overdue warning, dates, the person's details and the replies. */
export function RequestDetails({ request: r }: { request: AdminDataRequest }): React.JSX.Element {
  return (
    <>
      {!isAnswered(r.status) && r.overdue ? (
        <Alert tone="danger" title="This request is overdue">
          The deadline was {fmt.date(r.dueAt)}. Answer it as soon as possible.
        </Alert>
      ) : null}

      <dl className="nb-kv">
        <div>
          <dt>Status</dt>
          <dd>
            <Badge label={STATUS_LABEL[r.status]} tone={STATUS_TONE[r.status]} />
          </dd>
        </div>
        <div>
          <dt>Sent</dt>
          <dd>{fmt.dateTime(r.createdAt)}</dd>
        </div>
        <div>
          <dt>Deadline</dt>
          <dd>
            {fmt.date(r.dueAt)}
            {r.extended ? " (extended)" : ""}
          </dd>
        </div>
        {r.resolvedAt ? (
          <div>
            <dt>Answered</dt>
            <dd>{fmt.dateTime(r.resolvedAt)}</dd>
          </div>
        ) : null}
      </dl>

      <TextSection title="Details from the person" text={r.details?.trim() ? r.details : "No details given."} />
      {r.extended && r.extensionReason ? <TextSection title="Why the deadline was extended" text={r.extensionReason} /> : null}
      {r.resolution ? <TextSection title="Answer sent" text={r.resolution} /> : null}
    </>
  );
}
